import styles from './provider-chip.module.css';

const PROVIDERS: Record<string, { cls: string; label: string }> = {
  AWS: { cls: styles.pvAws, label: 'aws' },
  AZURE: { cls: styles.pvAz, label: 'Az' },
  GCP: { cls: styles.pvGcp, label: 'G' },
};

/**
 * Monospace provider pill ("aws" / "Az" / "G") shown next to account names
 * in tables. The provider is matched case-insensitively against the known
 * clouds; unknown or empty values render nothing instead of guessing a
 * brand, mirroring the sidebar badge behavior.
 */
export function ProviderChip({ provider }: { provider: string | undefined }) {
  if (!provider) {
    return null;
  }
  const badge = PROVIDERS[provider.toUpperCase()];
  if (!badge) {
    return null;
  }
  return <span className={`${styles.pv} ${badge.cls}`}>{badge.label}</span>;
}
